var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygonHide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "27px",
    height: "27px",
    viewBox: "0 0 21.297 15.66",
    style: {
      color: "rgb(33, 49, 69)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(-1660.699 -133.898)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M-2993.821-1575.375h-5.766l-2.882,4.993,2.882,4.993h5.766l2.882-4.993Z",
    transform: "translate(4663.167 1709.272)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M-2994.22-1575.047h-5.766l-2.882,4.993,2.882,4.993h5.766l2.882-4.993Z",
    transform: "translate(4673.334 1714.619)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonHide);
export default __webpack_public_path__ + "static/media/polygonHide.f6c46ba43eb12c00f5c0733c8077b88e.svg";
export { ForwardRef as ReactComponent };